import React, { useEffect, useState } from "react";
import {
  getUploadFileCategory,
  uploadFile,
} from "../../services/FileUploadService";
import { getFileName, isEmpty, getFileExtinsion } from "../../Utils/Helper";
import Select from "react-select";
import { FiEdit } from "react-icons/fi";
import {
  getSupplementData,
  getSupplementQuantity,
} from "../../services/CreateCarePlanService";
import { FaTrash } from "react-icons/fa";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { StaticTimePicker } from "@mui/x-date-pickers";
// const NoOptionsMessage = (props) => {
//   return (
//     <components.NoOptionsMessage {...props}>
//       <span>Start searching now</span>
//     </components.NoOptionsMessage>
//   );
// };

const SupplementsModal = ({
  supplimentDetails,
  setSupplimentsDetails,
  posDataFn,
  onClickEvent,
}) => {
  // let location = useLocation();
  // let plan = location?.state?.careplan || [];
  // let supplementDetails = location?.state?.supplements || [];
  // const navigate = useNavigate();

  const [error, setError] = useState(false);
  const [medicationName, setMedicationName] = useState({label:'',
value:''});
  // const [isLoading, setLoader] = useState(false);
  const [quantity, setQuantity] = useState("");
  const [searchWord, setSearchWord] = useState("");
  const [schedule, setSchedule] = useState("Everyday"); // eslint-disable-next-line
  const [ch, setch] = useState("00"); // eslint-disable-next-line
  const [cm, setcm] = useState("00");
  const [supplementName, setSupplementName] = useState([]); // eslint-disable-next-line
  const [image, setImage] = useState(""); // eslint-disable-next-line
  const [flname, setflname] = useState("");
  const [editIndex, setEditIndex] = useState(-1);
  const [selectedTime, setSelectedTime] = useState(new Date()); // eslint-disable-next-line
  const [endTime, setEndTime] = useState("1:00 AM");
  const [showTimePicker, setShowTimePicker] = useState(false);
  const today = dayjs(); // eslint-disable-next-line
  const [startTime, setStartTime] = useState("");
  const [note, setNote] = useState("");
  const [recommendedUse, setRecommendedUse] = useState("With meals");

  const [value, setValue] = useState(
    dayjs(
      `${today.format("YYYY-MM-DD")}T${
        startTime ? `${moment(startTime, ["HH:mm"]).format("HH:mm A")}` : null
      }`
    )
  );
  useEffect(() => {
    setShowTimePicker(false);
    setSelectedTime("1:00 PM");
  }, []);
  // const [allFormData, setAllFormData] = useState([]);
  const checkValidation = () => {
    try {
      let errorsResult = error;
      let isValid = true;
      if (!medicationName.label || isEmpty(medicationName.label)) {
        isValid = false;
        errorsResult = { ...errorsResult, medicationName: true };
      }
      // if (!searchWord || isEmpty(searchWord)) {
      //   isValid = false;
      //   errorsResult = { ...errorsResult, searchWord: true };
      // }
      if (!quantity || isEmpty(quantity)) {
        isValid = false;
        errorsResult = { ...errorsResult, quantity: true };
      }
      if (!schedule || isEmpty(schedule)) {
        isValid = false;
        errorsResult = { ...errorsResult, schedule: true };
      }

      setError(errorsResult);
      if (isValid) {
        handleData({
          supplementName: {label : medicationName.label,
          value : medicationName.value},
          quantity: quantity,
          time: selectedTime,
          schedule: schedule,
          recommendedUse: recommendedUse,
          note: note,
        });
        setError(false);
      }
    } catch (error) {}
  };
  const handleFormChange = (index, event) => {
    setEditIndex(index);
    const myArray = event.time.split(":");
    setch(myArray[0]);
    setcm(myArray[1]);
    // console.log(event, "event");

    let data = [...supplimentDetails];
    // console.log(data, "event Data");
    setMedicationName(event?.supplementName);
    setQuantity(event?.quantity);
    setSchedule(event?.schedule);
    // timeSetting(event.time)
    data[index][event?.medicineName] = event?.target?.value;
    data[index][event?.quantity] = event?.target?.value;
    data[index][event?.schedule] = event?.target?.value;
    data[index][event?.recommendedUse] = event?.target?.value;
    data[index][event?.note] = event?.target?.value;
    setSelectedTime(data[index].time);
    // data[index][event.myArray[0]] = event.target.value;
    // data[index][event.myArray[1]] = event.target.value;
    setSupplimentsDetails(data);
  };

  const handleData = (data) => {
    if (editIndex > -1) {
      let arr = [...supplimentDetails];
      arr[editIndex] = data;
      setSupplimentsDetails(arr);
    } else {
      setSupplimentsDetails([...supplimentDetails, data]);
    }
  };
  let removeFormFields = (i) => {
    let newFormValues = [...supplimentDetails];
    newFormValues.splice(i, 1);
    setSupplimentsDetails(newFormValues);
  };
  // const timeSetting = (date12, date24) => {
  //   const myArray = date24.split(":");
  //   setch(myArray[0] < 10 ? "0" + myArray[0] : myArray[0]);
  //   setcm(myArray[1]);
  // };

  // const handleSubmit = async (e) => {

  //     e.preventDefault();

  // }
  const getSupplementList = async (searchWord1) => {
    try {
      const response = await getSupplementData(searchWord1);
      // setLoader(false)
      console.log(searchWord1, "search");
      if (response) {
        // console.log(response.data.hits, "supplements")
        setSupplementName(response.data.hits);
        setMedicationName({
          label: response.data.hits[0]._source.fullName,
          value: response.data.hits[0]._id,
        });
        getSupplementQuantityData(response.data.hits[0]._id);
      }
    } catch (error) {
      // setLoader(false)
      console.log(error);
    }
  };
  const getSupplementQuantityData = async (supplementId) => {
    try {
      const response = await getSupplementQuantity(supplementId);
      if (response) {
        // console.log(response.data.servingSizes[0].minQuantity, "supplements quantity")
        setQuantity(response.data.servingSizes[0].minQuantity.toString());
      }
    } catch (error) {
      // setLoader(false)
      console.log(error);
    }
  };
  // useEffect(() => {
  //     setAllFormData(supplimentDetails);
  // }, [])

  const getList = () => {
    const result = supplementName.map((item) => {
      return {
        label: item._source.fullName,
        value: item._id,
      };
    });
    // setDefaultSupplement(result[0]);
    return result || [];
  };
  // const uploadPicture = async (e) => {
  //   setImage(e.target.files[0]);
  //   const filename = getFileName(e.target.files[0]);
  //   const fileExtinsion = getFileExtinsion(e.target.files[0]);
  //   try {
  //     await uploadFile(
  //       e.target.files[0],
  //       getUploadFileCategory.recipe,
  //       filename + "." + fileExtinsion
  //     );
  //     setflname(filename + "." + fileExtinsion);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const renderList = () => {
    return (
      <table class="table table-hover">
        <thead>
          <th>Supplement Name</th>
          <th>Quantity</th>
          <th>Schedule</th>
          <th>Time</th>
          <th>Recommended Use</th>
        </thead>
        <tbody>
          {supplimentDetails?.map((item, index) => {
            return (
              <>
                <tr>
                  <td className="text-muted border-0 ">{item.supplementName.label}</td>
                  <td className="text-muted border-0 ">{item.quantity}</td>
                  <td className="text-muted border-0 ">{item.schedule}</td>
                  <td className="text-muted border-0 ">
                    {item.schedule === "Every morning" ||
                    item.schedule === "Every night" ||
                    item.schedule === "Everyday"
                      ? item.time
                      : ""}
                  </td>
                  {/* <td className="text-muted">{item.note}</td> */}
                  <td className="text-muted border-0 ">{item.recommendedUse}</td>
                  <td
                    className="text-muted border-0  fw-bold text-left overflow-visible"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex gap-1">
                      <button
                        type="button"
                        onClick={() => removeFormFields(index)}
                        className="btn btn-light"
                      >
                        <FaTrash className="mb-1" />
                      </button>
                      <button
                        type="button"
                        onClick={() => handleFormChange(index, item)}
                        className="btn btn-light"
                      >
                        <FiEdit className="mb-1" />
                      </button>
                    </div>
                    {/* <Dropdown>
                                        <Dropdown.Toggle variant="light" className="custom" id="dropdown-basic">
                                            <BsThreeDots className="icon" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item type="button" onClick={() => removeFormFields(index)}>Delete</Dropdown.Item>
                                            <Dropdown.Item type="button" onClick={() => handleFormChange(index, item)}>Edit</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown> */}
                  </td>
                </tr>
                {item.note ? (
                  <tr>
                    <td className="text-muted" colSpan={6}>
                      <span className="fw-bold">Note: </span>
                      {item.note}
                    </td>
                  </tr>
                ) : (
                  <tr>
                  <td className="text-muted" colSpan={6}>
                  </td>
                </tr>
                )}
              </>
            );
          })}
        </tbody>
      </table>
    );
  };

  const renderForm = () => {
    return (
      <>
        <div className="my-1">
          {/* <h2>Supplements</h2> */}
          {/* <p className="resFont">View and fill in client supplements.</p> */}
        </div>
        {/* <div className="col-md-12 actsearch_medi mb-4 ">
                    <FiSearch className="boxicon" />
                    <input
                        placeholder="Search for supplements-mineral,vitamin,herb...."
                        className="ms-2"
                        onChange={(e) => {
                            getSupplementList(e.target.value);
                            setSearchWord(e.target.value)
                        }}
                        value={searchWord}
                    />
                </div> */}
        {/* <form onSubmit={handleSubmit}> */}

        <div className="row   add-recipe">
          {/* <div className="col-md-4">
            <img src="images/medicine.png" alt="image" width="100%" />
          </div> */}
          <div className="col-md-12">
            <div className="row">
              {/* <div className="col-md-12">
                <p className="whole_label resFont  ">
                  Supplement{" "}
                  <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                </p>
                <input
                  type="text"
                  placeholder="Search for supplements-mineral,vitamin,herb...."
                  className="description_inputf"
                  onChange={(e) => {
                    getSupplementList(e.target.value);
                    setSearchWord(e.target.value);
                  }}
                  value={searchWord}
                />
              </div>
              {error && !searchWord && (
                <h2 className="text-danger error">
                  Search condition type to continue.
                </h2>
              )} */}
              <div className="col-md-12">
                <p className="whole_label resFont">
                  Supplements Name{" "}
                  <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                </p>
                <input
                  placeholder={"Select supplement from the list..."}
                  className=" description_inputf"
                  min={0}
                  value={medicationName.label}
                  onChange={(e) => {
                    setMedicationName({...medicationName,label:e.target.value, value:'1'});
                  }}
                />
                {error && !medicationName.label && (
                  <h2 className="text-danger error">
                    Supplement name should not be empty.
                  </h2>
                )}
                {/* <input
                                        type="text"
                                        className="description_inputMedi  "
                                        placeholder="List all medications-Vitamins,Minerals,Herbs"
                                        value={medicationName}
                                        maxLength="40"
                                        onChange={(e) => setMedicationName(e.target.value)}
                                    />
                                    {(error && !medicationName) && <h2 className="text-danger error">Medication name should not be empty.</h2>} */}
              </div>
              <div className="col-md-12">
                <p className="whole_label resFont  ">
                  Instructions{" "}
                  <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                </p>
              </div>
              <div className="col-md-6">
                <p className="whole_label resFont text-secondary">Quantity</p>
                <input
                  className="description_inputf"
                  placeholder="1 or 2"
                  value={quantity}
                  min={0}
                  onChange={(e) => {
                    setQuantity(e.target.value);
                  }}
                />
                {error && !quantity && (
                  <h2 className="text-danger error">
                    Quantity should not be empty.
                  </h2>
                )}
              </div>
              <div className="col-md-6">
                <p className="whole_label resFont text-secondary">Schedule</p>
                <select
                  className="description_inputf  "
                  value={schedule}
                  onChange={(e) => setSchedule(e.target.value)}
                >
                  <option value="Everyday">Everyday</option>
                  <option value="Twice/day">Twice/day</option>
                  <option value="Three Times/day">Three Times/day</option>
                  <option value="Four Times/day">Four Times/day</option>
                  <option value="Every morning">Every morning</option>
                  <option value="Every night">Every night</option>
                </select>
                {error && !schedule && (
                  <h2 className="text-danger error">
                    Schedule should not be empty.
                  </h2>
                )}
              </div>
              <div className="col-md-6">
                <p className="whole_label resFont text-secondary">Recommended Use</p>
                <select
                  className="description_inputf  "
                  value={recommendedUse}
                  onChange={(e) => setRecommendedUse(e.target.value)}
                  // onChange={(e) => setRecommendedUse(e.target.value)}
                >
                  <option value="After meals">After meal</option>
                  <option value="With meals">With meals</option>
                  <option value="Between meals">Between meals</option>
                  <option value="On an empty stomach">
                    On an empty stomach
                  </option>
                </select>
                {error && !recommendedUse && (
                  <h2 className="text-danger error">
                    Recommended use should not be empty.
                  </h2>
                )}{" "}
              </div>
              {/* <div className="row"> */}
              <div className="col-md-6">
                <p className="whole_label resFont text-secondary">Time</p>
                <input
                  // type="number"
                  className="description_inputf"
                  placeholder="Click here to add time"
                  value={selectedTime}
                  onChange={(e) => {
                    // setQuantity(e.target.value);
                  }}
                  onClick={() => setShowTimePicker(true)}
                />
                {/* {(error && (ch <= 0 && cm <= 0)) && <h2 className="text-danger error">Time cannot not be 0.</h2>} */}
              </div>
              {/* </div> */}
              {showTimePicker && (
                <div
                  className="col-md-12"
                  style={{ border: "3px solid #d9d9d9" }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["StaticTimePicker"]}>
                      <DemoItem>
                        <StaticTimePicker
                          orientation="landscape"
                          value={value}
                          views={["hours", "minutes"]}
                          format="hh:mm"
                          onChange={(newValue) => {
                            console.log(newValue);
                            setValue(newValue);
                            console.log(
                              dayjs(newValue, { format: "hh:mm" }).format(
                                "hh:mm:ss A"
                              )
                            );
                            setSelectedTime(
                              dayjs(newValue, { format: "hh:mm" }).format(
                                "hh:mm A"
                              )
                            );
                          }}
                          componentsProps={{
                            actionBar: {
                              // The actions will be the same between desktop and mobile
                              actions: [],
                            },
                          }}
                        />
                        <button
                          className="description_btnsave"
                          type="button"
                          onClick={() => {
                            setShowTimePicker(false);
                          }}
                        >
                          OK
                        </button>
                      </DemoItem>
                    </DemoContainer>
                  </LocalizationProvider>
                  {/* {(error && (ch <= 0 && cm <= 0)) && <h2 className="text-danger error">Time cannot not be 0.</h2>} */}
                </div>
              )}
            </div>
          </div>
          {/* <div className="col-md-12">
                        <div className="position-sticky" style={{ "top": 10 }}>
                            <img
                                src={(image && URL.createObjectURL(image)) || "images/dummy_image.jpg"}
                                alt=""
                                className="active_dummyimage"
                            />
                            <input type="file" className="form-control uploader-input_"
                                accept="image/*"
                                onChange={(e) => {
                                    uploadPicture(e);
                                }}
                            />
                            <div className="uploader-mask d-flex justify-content-center align-items-center">
                                <BsFillPlusCircleFill className="upload-icon" />
                            </div>
                            {(error && !image) && <h2 className="text-danger error">Picture should not be empty.</h2>}
                        </div>
                    </div> */}
          <div className="col-md-12">
            <p className="whole_label resFont  ">
              Note <span className="text-lowercase">for Patient</span>
            </p>
            <input
              type="text"
              className="description_inputMedi  "
              placeholder="Shots and vaccinations (including flu shots)"
              value={note}
              maxLength="40"
              onChange={(e) => setNote(e.target.value)}
            />
            {/* {(error && !note) && <h2 className="text-danger error">Note should not be empty.</h2>} */}
          </div>
          <div className="col-md-4 mt-4 ">
            <button
              type="button"
              className="description_btnsave justify-content-end flex-end"
              onClick={() => {
                checkValidation();
                //    handleData({
                //         supplementName: medicationName,
                //         quantity: quantity,
                //         time: `${ch}:${cm}`,
                //         schedule: schedule
                //     })

                setMedicationName({
                  label:'',
                  value:''
                });
                setSearchWord("");
                setQuantity("1");
                setch("00");
                setcm("00");
                setNote("");
                setEditIndex(-1);
              }}
            >
              {editIndex > -1 ? "Edit" : "Add"}
            </button>
          </div>
        </div>
        {/* </form> */}
        {supplimentDetails.length ? (
          <div className="col-md-12 mt-4">
            <p className="whole_label resFont  ">
              Supplements <span className="text-lowercase">added: </span>
            </p>
            {renderList()}
          </div>
        ) : null}
      </>
    );
  };
  return (
    <div
      class="modal fade"
      id="supplementsModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" style={{ maxWidth: "900px" }}>
        <div class="modal-content">
          <div class="modal-header p-4 border-0">
            <h5 className="ms-2">Supplements</h5>
            <button
              type="button"
              class="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <p style={{ marginLeft: 33, marginTop: -25 }}>
            View and fill in client supplements.
          </p>
          <div class="modal-body pb-4 px-4">
            <div className="container" style={{ marginBottom: 100 }}>
              <div className="row justify-content-start">{renderForm()}</div>
            </div>
            <hr />
            <div className="modal-footer px-5 border-0">
              <button
                type="button"
                onClick={() => {
                  document.getElementById("btn-close").click();
                  if (posDataFn) {
                    onClickEvent();
                  }
                }}
                data-bs-dismiss="modal"
                className="description_btnsave w-100 "
                style={{
                  backgroundColor: "#1F7E78",
                  borderColor: "#1f7e78",
                }}
              >
                {"Submit"}
              </button>
            </div>
            {/* <div className="col-md-12 mt-5">
                            <hr />
                            <div className="d-flex justify-content-right">
                                {/* <div text={'Cancel'} style={isLoading ? { cursor: 'none' } : { cursor: 'pointer', backgroundColor: '#fff', color: 'black', border: '1px solid #bbb9b9' }} className="description_btnsave d-flex justify-content-center align-items-center">Cancel</div> */}
            {/* <Button isLoading={isLoading} onClick={() => document.getElementById('btn-close').click()} id="reateProgram" data-bs-dismiss="modal" text={'Save & Continue'} style={isLoading ? { cursor: 'none' } : {}} className="description_btnsave" />
                            </div>
                        </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplementsModal;
